<template>
	<section>
		<div id="account-banner">
			<img src="../../assets/img/Hero-banner.png" alt="">
		</div>
		<div class="container mt-4">
			<h1>Page Not Found</h1>
			<div class="ui warning message">
				<div class="header">Sorry the page you are looking for was not found.</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "NotFound"
};
</script>